import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "TimezoneLoaderstyles__Container",
  componentId: "keen-query-creator__sc-1wybtw0-0"
})(["&&&{padding:25px 10px;display:flex;align-items:center;justify-content:center;background:", ";}"], colors.white[500]);
export var Wrapper = styled.div.withConfig({
  displayName: "TimezoneLoaderstyles__Wrapper",
  componentId: "keen-query-creator__sc-1wybtw0-1"
})(["&&&{margin-left:10px;}"]);